import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { ITabDetailsHOCProps } from './types';
import { TabDetails } from '../../containers/TabDetails/TabDetails';
import { ITabDetailsEvents, ITabDetailsFields } from '../../containers/TabDetails/types';
import { getCard } from '../../../../../../../store/model/selectors/getCard';
import { getSectionType } from '../../../selectors/getSectionType';
import { getAuthUserPlatformType } from 'app/store/model/authUser/selectors/getAuthUserPlatformType';
import {
    getUserCommentsColumnView
} from '../../../../../../../store/model/authUser/selectors/getUserCommentsColumnView';
import { getAsidePanelColumnWidth } from '../../../../asidePanel/store/selectors/getAsidePanelColumnWidth';
import { onColumnWidthChange } from './events/onColumnWidthChange';
import {
    getAsidePanelButtonsPanelIsMinimized
} from '../../../../asidePanel/store/selectors/getAsidePanelButtonsPanelIsMinimized';
import { getAsidePanelEntityPanelWidth } from 'app/view/react_components/aside_panel/asidePanel/store/selectors/getAsidePanelEntityPanelWidth';
import { onTurnOffCommentsColumn } from './events/onTurnOffCommentsColumn';

const mapStateToProps = (
    state: IApplicationState,
    ownProps: ITabDetailsHOCProps
): ITabDetailsFields => {
    const { boardId, cardId } = ownProps;
    const sectionType = getSectionType(state, boardId, cardId);
    let isShow = false;
    const card = getCard(state, cardId);

    if (card) {
        isShow = true;
    }

    return {
        asideWidth: getAsidePanelEntityPanelWidth(state),
        isActionsMinimized: getAsidePanelButtonsPanelIsMinimized(state),
        isCommentColumnView: getUserCommentsColumnView(state),
        isShow,
        cardId,
        columnWidth: getAsidePanelColumnWidth(state),
        boardId,
        platformType: getAuthUserPlatformType(state),
        sectionType
    }
};

const mapDispatchToProps = (
    dispatch: any,
    ): ITabDetailsEvents => ({
    onChangeColumnWidth: (columnWidth) => dispatch(onColumnWidthChange(columnWidth)),
    onTurnOffColumnView: () => dispatch(onTurnOffCommentsColumn()),
});

export const TabDetailsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(TabDetails);

TabDetailsHOC.displayName = 'TabDetailsHOC';
